/**
 * @fileoverview Handles the preview event to update the explorer gutter and bottom sections.
 * This is a simplified version that directly updates the sections without opening a dialog.
 */
import htmx from "htmx.org";

/**
 * Handles the 'preview' event to update the explorer sections.
 * @param e - The custom event containing the preview URL.
 */
function handlePreview(e: CustomEvent<string>) {
  htmx.ajax("get", e.detail, { swap: "patch" });
}

/**
 * Registers the 'preview' event listener to handle preview updates.
 */
document.addEventListener("preview", handlePreview);
